import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, PRIMARY_OUTLET } from '@angular/router';

import { filter } from 'rxjs/operators';
import { map } from 'rxjs/internal/operators';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  public breadcrumbs;
  public title: string

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }))
      .pipe(filter(route => route.outlet === PRIMARY_OUTLET))
      .subscribe(route => {
        let parent = route.parent.snapshot.data['breadcrumb'];
        if (parent == 'Content') {
          this.title = route.snapshot.params.name;
          this.breadcrumbs = Object.values(route.snapshot.params);
        }
        else {
          let title = route.snapshot.data['title'];
          let child = route.snapshot.data['breadcrumb'];
          this.breadcrumbs = {};
          this.title = title;
          this.breadcrumbs = [
            parent,
            child
          ]
        }
      });
  }

  ngOnInit() { }

  ngOnDestroy() { }

}

